import { useEffect } from 'react';
import Header from '../components/Header/Header';
import NotificationBar from '../components/NotificationBar/NotificationBar';
import VideoHeroSection from '../components/VideoHeroSection/VideoHeroSection';
import AboutSection from '../components/AboutSection/AboutSection';
import CommunitySection from '../components/CommunitySection/CommunitySection';

import JoinUs from '../components/Joinus/JoinUs';
import ModernFooter from '../components/ModernFooter/ModernFooter';
import BreadcrumbSchema from "./BreadcrumbSchema";
import AppleCardsCarouselDemo from "../components/Ui-Scroller/Appledemo";
import Carousel from "../components/Carosel/Carosel";
import PartnerNetwork from "../components/PartnerNetwork/PartnerNetwork";
function Home() {
  useEffect(() => {
    // Ensure dark mode is applied
    document.documentElement.classList.add('dark');
  }, []);

  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <BreadcrumbSchema />
      <Header />
      <div className="mt-16">
        <NotificationBar />
      </div>
      <VideoHeroSection />
      
      
      <AboutSection />
      <Carousel />
      <AppleCardsCarouselDemo />
      <PartnerNetwork />
      <CommunitySection />
      <JoinUs />
      <ModernFooter />

    </div>
  );
}

export default Home;
